import React from "react";

export default function MainPage() {
  return (
    <div className="p-8 max-w-3xl mx-auto">
      <h1 className="text-4xl font-bold mb-4">
        Building Intelligent Tools That Understand You
      </h1>
      <p className="mb-6 text-lg">
        At <strong>Waterstream AI</strong>, we design cutting-edge AI products
        that elevate how people interact with data, emotions, and decisions.
        Whether it's analyzing complex documents or nurturing mental wellness,
        our tools are built to make life simpler, smarter, and more human.
      </p>

      <h2 className="text-2xl font-bold mt-10 mb-4">🚀 Why Waterstream AI?</h2>
      <ul className="list-disc list-inside mb-6">
        <li>🌐 Cutting-edge AI, human-first design</li>
        <li>🔐 Security and privacy baked into every layer</li>
        <li>⚙️ Seamless experiences across business and personal life</li>
        <li>💡 Innovation with empathy</li>
      </ul>

      <h2 className="text-2xl font-bold mt-10 mb-4">👥 Who We Serve</h2>
      <ul className="list-disc list-inside mb-6">
        <li>Enterprises & professionals (via Waterstream Insight)</li>
        <li>Individuals & therapists (via HugMySelf)</li>
        <li>Startups & researchers seeking powerful, accessible AI tools</li>
      </ul>

      <h2 className="text-2xl font-bold mt-10 mb-4">📬 Let’s Connect</h2>
      <p className="mb-2">Want to see Waterstream Insight in action?</p>
      <p className="mb-2">Interested in beta access to HugMySelf?</p>
      <p className="mb-6">
        Have feedback or ideas? We’d love to hear from you!
      </p>
    </div>
  );
}
